import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/exports",
        name: "secure-exports",
        component: () => import("@/views/modules/exports/index.vue"),
        meta: {
            contentClass: "module-secure-exports",
            resource: "secure-exports",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/exports/conversations",
        name: "secure-exports-conversations",
        component: () => import("@/views/modules/exports/conversations/secureExports.vue"),
        meta: {
            contentClass: "module-secure-exports",
            resource: "secure-exports",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/exports/contacts",
        name: "secure-exports-contacts",
        component: () => import("@/views/modules/exports/contacts/index.vue"),
        meta: {
            contentClass: "module-secure-exports",
            resource: "secure-exports",
            action: "read",
        },
        beforeEnter: isUserLoggedIn,
    },
];
